module.exports = __webpack_public_path__ + "static/crashlytics-icon-8e3715e52025126bf3d361d321b9eef7.png";